import { EntryListContent } from '@/api/interfaces/content/common/entryListContent';

export const messageDialogueContent: EntryListContent = {
    newApplicationText: 'Neuer Antrag',
    toSafetyButtonText: 'Zur Übersicht',
    closeButtonText: 'Schließen',
};
